import React, { ReactElement, useState, cloneElement } from 'react';
import { classNames } from '../../utils/style';
import { VideoModalContext } from '../VideoModal/VideoModalContext';
import { ModalVideoContent } from '../VideoModal/ModalVideoContent';
import { fontBodyMiniMedium, fontCaption } from '../../styles/typographyNew';

export type CardVideoProps = {
  logo?: ReactElement;
  image?: ReactElement;
  subtitle?: string;
  title?: string;
  overlay?: string;
  onClick?: (e: any) => void;
  VideoPlayer?: ReactElement;
};

export const CardVideo: React.FC<CardVideoProps> = ({
  logo,
  image,
  title,
  subtitle,
  overlay,
  VideoPlayer,
  onClick,
}) => {
  const [showVideo, setShowVideo] = useState(false);

  const toggleVideo = (e: any) => {
    onClick && onClick(e);
    setShowVideo(!showVideo);
  };

  const background = () => {
    if (overlay === 'Cyan') return 'bg-[#009299CC]'; // Cyan
    if (overlay === 'Blue') return 'bg-[#0F5CEEB2]'; // Blue
    if (overlay === 'Purple') return 'bg-[#6157FCCC]'; // Purple
    if (overlay === 'Turquoise') return 'bg-[#03B9B9CC]'; // Turquoise
    if (overlay === 'Midnight Blue') return 'bg-[#08337CCC]'; // Midnight Blue
    if (overlay === 'Teal') return 'bg-[#30ACB3CC]'; // Teal

    return 'bg-[#0F6FDECC]';
  };

  return (
    <VideoModalContext.Provider
      value={{
        toggleVideo,
        showVideo,
        VideoPlayer,
      }}
    >
      <button
        className={classNames(
          'CardVideo',
          'mx-auto rounded-[20px] overflow-hidden',
          'w-[460px] h-[320px] group',
          'shadow-videoTestimonial hover:shadow-videoTestimonialHover',
          'relative hover:-translate-y-[10px] transition-all',
        )}
        onClick={toggleVideo}
      >
        <div className="relative overflow-hidden w-full h-full rounded-[20px]">
          {image &&
            cloneElement(image, {
              className: classNames(
                image.props.className,
                'w-full h-full object-cover saturate-0',
              ),
            })}
          <div
            className={classNames(
              background(),
              'absolute top-0 bottom-0 left-0 right-0 flex items-center justify-center',
            )}
          >
            <div
              className={classNames(
                'bg-[#0420409F] hover:bg-[#042040] w-[90px] h-[90px] rounded-full opacity-100',
                'flex items-center justify-center',
                'shadow-videoPlayBtn group-hover:shadow-videoPlayBtnHover',
                'transition-all',
              )}
            >
              <svg
                width="23"
                height="26"
                viewBox="0 0 23 26"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="w-[25px] h-32"
              >
                <path
                  d="M7.82934 1.24092C4.70876 -0.744906 0.625244 1.49673 0.625244 5.19559V20.9299C0.625244 24.6288 4.70876 26.8704 7.82935 24.8846L20.192 17.0174C23.0866 15.1754 23.0866 10.9501 20.192 9.10808L7.82934 1.24092Z"
                  fill="white"
                />
              </svg>
            </div>
            {logo && (
              <div className="absolute top-0 right-0 p-24">
                {cloneElement(logo, {
                  className: classNames(
                    logo.props.className,
                    'max-w-[108px] w-full',
                  ),
                })}
              </div>
            )}
            <div className="absolute bottom-0 left-0 p-24 text-left">
              <div className={classNames(fontBodyMiniMedium, 'text-white')}>
                {title}
              </div>
              <div className={classNames(fontCaption, 'text-white opacity-70')}>
                {subtitle}
              </div>
            </div>
          </div>
        </div>
      </button>
      <ModalVideoContent />
    </VideoModalContext.Provider>
  );
};
